import React, { useContext, useEffect, useRef, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Popup from "reactjs-popup";
import { SpinnerDotted } from 'spinners-react';
import { toast } from 'react-toast';
import { Forge as ForgeUtil } from "ec-util";
import path from "path";

import { parseRpcError } from '../Utils';
import { getContract } from '../Utils/GetContract';
import Web3Ctx from '../Context/Web3Ctx';
import config from '../../config'

import Navigation from '../Navigation/Navigation';
import ImageView from '../common/ImageView';
import ForgeHistory from '../common/ForgeHistory';
import NftCardV2 from '../common/NftCardV2';
import useContainerDimensions from '../common/useContainerDimensions';

import './ForgePage.css';
import ecLogo from '../../assets/images/logo-in-menu.png';
import icClose from '../../assets/images/close.png';
import icDnd from '../../assets/images/dnd.png';
import icInfo from '../../assets/images/info.png';
import icForgeProtector from '../../assets/images/forge-protector.png';

import { getTokenURI, getLayersURI } from '../Utils';
import { usePrevious, useWindowDimensions } from '../Utils/CustomHooks';

//TRAIT ICONS
import PLACEHOLDER from '../../assets/images/traits/small_rplaceholder_icon.png';

const forgeUtil = new ForgeUtil();

const CardTraits = ({ state, tokenMetadata, handleSelectCardTrait }) => {
    const [traitsOfToken, setTraitsOfToken] = useState([]);
    const containerRef = useRef()
    const { height, width } = useWindowDimensions();
    const isMobile = width <= 480;

    useEffect(() => {
        if (tokenMetadata && tokenMetadata.traits) {
            setTraitsOfToken(tokenMetadata.traits)
        }
    }, [tokenMetadata])

    const renderTraitIcon = (trait) => {
        const traitIcon = `${process.env.PUBLIC_URL}/traits/${trait.icon}`;
        return (
            <img style={{ width: '80%' }}
                src={traitIcon}
                onError={(e) => {
                    e.target.src = PLACEHOLDER;
                    e.target.onerror = null;
                }}>
            </img>
        )
    }

    const renderTraitInfoPopup = (trait, i) => {
        return (
            <Popup
                trigger={
                    <div key={'trait-' + i}
                        className='trait'
                        style={{ width: '27%', height: '20%', margin: '4px' }}>
                        {renderTraitIcon(trait)}
                    </div>
                }
                modal={isMobile}
                on={isMobile ? 'click' : 'hover'}
                // on="hover"
                position="top"
            >
                {close => {
                    return (
                        <div class="trait-popup">
                            <h5 className="trait-name">{trait.name}</h5>
                            <p className="mt-3 px-3">{trait.description}</p>
                        </div>)
                }}
            </Popup>
        )
    }

    return (
        tokenMetadata && tokenMetadata.traits &&
        <div key={`trait_${tokenMetadata.id}`}
            ref={containerRef}
            className={`trait-card-container traits-on ${state[5].tokenId === tokenMetadata.id ? 'selected' : ''}`}
            onClick={() => handleSelectCardTrait(tokenMetadata.id)}>
            <div className="trait-slide pb-1 px-3 text-center">
                <div className={`trait-container`}>
                    {traitsOfToken.map(renderTraitInfoPopup)}
                </div>
            </div>
        </div>
    )
}

const ForgePage = (props) => {
    const baseCid = config.BASE_CID;
    const layersBaseUrl = config.LAYERS_BASE_URL;
    const chainId = config.DEPLOYED_CHAIN_ID;

    const { onboard, address, ethersProvider } = useContext(Web3Ctx);
    const [isConnected, setIsConnected] = useState(false);
    const [uploadCardAmount, setUploadCardAmount] = useState(0);
    const [eligibleCardAmount, setEligibleCardAmount] = useState(0);
    const [uploadCard, setUploadCard] = useState([null, null]);
    const [hasForgeProtector, setHasForgeProtector] = useState([false, false]);
    const prevCards = usePrevious({ uploadCard });

    const [showButton, setShowButton] = useState(false);
    const [showConfirmForgeButton, setShowConfirmForgeButton] = useState(false);
    const [showForgeSuccessful, setShowForgeSuccessful] = useState(false);

    const [showForgeStepOne, setShowForgeStepOne] = useState(false);
    const [showForgeStepTwo, setShowForgeStepTwo] = useState(false);
    const [showCardHoldings, setShowCardHoldings] = useState(true);

    const [forgeCardStateOne, setForgeCardStateOne] = useState([{}, {}, {}, {}, {}, {}]);
    const [showLoader, setShowLoader] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [cardArtwork, setCardArtwork] = useState('');
    const [showTokenIdHistory, setShowTokenIdHistory] = useState('');
    const [cards, setCards] = useState([]);
    const [ec, setEc] = useState(null);
    const [forgeContract, setForgeContract] = useState(null);

    useEffect(() => {
        console.log('FORGE');
        const initContract = async () => {
            const contract = await getContract(`${chainId === 1 ? "EtherCards" : "NFTToolbox"}`, ethersProvider).catch(e => console.log('err:', e));
            //const contract3 = await getContract('NFTToolbox', ethersProvider).catch(e => console.log('err:', e));
            const contract2 = await getContract('EtherCardsForge', ethersProvider).catch(e => console.log('err:', e));
            setEc(contract);
            setForgeContract(contract2);
        }
        if (ethersProvider) {
            initContract();
        }
    }, [ethersProvider]);

    useEffect(() => {
        if (ec && forgeContract && address) {
            // console.log('about to get tokens [ec,forgeContract, address]', ec, forgeContract, address);
            setIsConnected(true);
            getTokens();
        } else {
            setIsConnected(false);
        }
    }, [ec, forgeContract, address]);

    useEffect(() => {
        setEligibleCardAmount(cards.length)
    }, [cards])

    useEffect(() => {
        console.info('set upload card')
        const notNullable = uploadCard.filter(obj => obj !== null);
        setUploadCardAmount(notNullable.length);
        setShowButton(notNullable.length == 2);
        console.info(uploadCard)

        if (prevCards) {
            uploadCard.forEach(async (tokenMetadata, index) => {
                if (tokenMetadata !== prevCards.uploadCard[index]) {
                    const newForgeProtectorState = [...hasForgeProtector];
                    if (tokenMetadata) {
                        const hasProtector = await checkHasForgeProtector(tokenMetadata);
                        newForgeProtectorState[index] = hasProtector;
                        setHasForgeProtector(newForgeProtectorState);
                        console.info(`${tokenMetadata.id} has ForgeProtector: ${hasProtector}`)
                    } else {
                        newForgeProtectorState[index] = false;
                        console.info(`Setting forgeProtector for Upload Card ${index + 1} to null`)
                        setHasForgeProtector(newForgeProtectorState)
                    }
                }
            })
        }
    }, [uploadCard]);

    useEffect(() => {
        const notNullable = forgeCardStateOne.filter(obj => obj.tokenId && obj.tokenId !== null)
        setShowConfirmForgeButton(showForgeStepOne ? notNullable.length == 5 : notNullable.length == 6);
    }, [forgeCardStateOne, showForgeStepOne, showForgeStepTwo])

    const checkHasForgeProtector = async (tokenMetadata) => {
        let hasForgeProtector = await forgeContract.ForgeProtector(tokenMetadata.id);
        return hasForgeProtector;
    }

    const getTokens = async () => {
        if (!ec) {
            toast.error('Contract not found');
            return;
        }
        setIsLoading(true);
        const numberOfTokens = await ec.balanceOf(address); //BigNumber
        if (numberOfTokens.toNumber() > 0) {
            let metadata = [];
            for (let i = 0; i < numberOfTokens; i++) {
                const tokenId = await ec.tokenOfOwnerByIndex(address, i);
                const meta = await getTokenURI(resolveTokenJsonUri(tokenId));
                metadata.push(meta);
            }
            setCards(metadata.sortBy('id'));
            setUploadCard([null, null]);
        } else {
            setCards([]);
        }
        setIsLoading(false);
    }

    const showImage = (imgUrl) => {
        setCardArtwork(imgUrl);
    }

    const showForgeHistory = (tokenId) => {
        setShowTokenIdHistory(tokenId);
    }

    const uploadCardRef = useRef()
    const { width, height } = useContainerDimensions(uploadCardRef)
    const getItemStyle = (isDragging) => {
        if (isDragging) {
            return {
                height: height,
                width: width
            }
        }
    };
    const getDroppableStyle = (isDraggingOver) => {
        return {
            // change background colour if dragging
            position: 'absolute',
            top: 0,
            left: 0,
            backgroundColor: isDraggingOver ? "#8000807d" : "#1c1e24",
            opacity: isDraggingOver ? "0.4" : "1",
            height: '100%',
            width: width,
            border: '3px dashed purple',
            borderRadius: '20px',
            overflow: 'hidden'
        }
    };

    const getForgeContainerStyle = () => {
        return {
            backgroundColor: '#1c1e24'
        }
    }

    const forgeSectionStyle = () => {
        return {
            backgroundColor: !showCardHoldings ? '#1c1e24' : "#17191f"
        }
    }

    const onDragEnd = (result) => {
        const { source, destination, draggableId } = result;
        if (!result.destination) {
            return;
        }
        if (
            source.droppableId === destination.droppableId &&
            source.index === destination.index
        ) {
            return;
        }

        const holdingCards = [...cards];
        const newUploadCards = [...uploadCard];
        const cardMetadata = cards.find(card => `${card.id}` === `${draggableId}`);
        if (destination.droppableId === 'uploadCardOne') {
            holdingCards.splice(source.index, 1);
            setCards(holdingCards);
            newUploadCards.splice(0, 1, cardMetadata);
            if (uploadCard[0]) {
                holdingCards.splice(0, 0, uploadCard[0])
            }
            setUploadCard(newUploadCards);
            setCards(holdingCards)
        } else if (destination.droppableId === 'uploadCardTwo') {
            holdingCards.splice(source.index, 1);
            setCards(holdingCards);
            newUploadCards.splice(1, 1, cardMetadata);
            if (uploadCard[1]) {
                holdingCards.splice(0, 0, uploadCard[1])
            }
            setUploadCard(newUploadCards);
            setCards(holdingCards)
        } else {
            const reorderedCards = reorder(
                cards,
                source.index,
                destination.index
            );
            setCards(reorderedCards);
        }
    }

    // a little function to help us with reordering the result
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    const getStyle = (style, snapshot) => {
        if (!snapshot.isDropAnimating) {
            return style;
        }
        const { moveTo, curve, duration } = snapshot.dropAnimation;
        // move to the right spot
        let translate = ''
        if (snapshot.draggingOver === 'uploadCardOne' || snapshot.draggingOver === 'uploadCardTwo') {
            //translate = `translate(${moveTo.x-69}px, ${moveTo.y-365}px)`;
        }
        // add a bit of turn for fun
        const rotate = 'rotate(0.5turn)';
        // patching the existing style
        let newStyle = {};
        if (translate !== '') {
            //newStyle.transform = translate;
        }
        return {
            ...style,
            ...newStyle,
            //transform: `${translate} ${rotate}`,
            // slowing down the drop because we can
            paddingLeft: 0,
            transition: `all ${curve} ${duration}s`,
        };
    }

    const handleRemoveCard = (index, tokenMetadata) => {
        if (showCardHoldings) {
            const holdingCards = [...cards];
            const newUploadCards = [...uploadCard];
            holdingCards.splice(0, 0, tokenMetadata);
            newUploadCards[index] = null;
            setCards(holdingCards);
            setUploadCard(newUploadCards);
        }
    }

    const handleSelectLayer = (tokenId, index) => {
        const newStateOne = [...forgeCardStateOne];
        newStateOne[index].tokenId = tokenId;
        setForgeCardStateOne(newStateOne)
    }

    const handleSelectCardTrait = (tokenId) => {
        const newStateOne = [...forgeCardStateOne];
        newStateOne[5].tokenId = tokenId;
        setForgeCardStateOne(newStateOne)
    }

    const forgeNow = () => {
        if (showCardHoldings) {
            setShowCardHoldings(false);
            setShowForgeStepOne(true);
        }
    }

    const back = () => {
        if (showCardHoldings) {
            // reset all
            const holdingCards = [...cards];
            holdingCards.push(uploadCard[0], uploadCard[1]);
            setCards(holdingCards);
            setUploadCard([null, null]);
            setShowCardHoldings(true);
            setShowForgeStepOne(false);
            setShowForgeStepTwo(false);
            setForgeCardStateOne([{}, {}, {}, {}, {}, {}]);
        } else if (showForgeStepOne) {
            setShowCardHoldings(true);
            setShowForgeStepOne(false);
        } else if (showForgeStepTwo) {
            let state = [...forgeCardStateOne]
            state[5] = {}
            setForgeCardStateOne(state);
            setShowForgeStepOne(true);
            setShowForgeStepTwo(false);
        }
    }

    const forgeStepTwo = () => {
        setShowForgeStepOne(false);
        setShowForgeStepTwo(true);
    }

    const clearAll = () => {
        setShowLoader(false)
        setUploadCard([null, null]);
        setShowCardHoldings(true);
        setShowForgeStepTwo(false);
        setShowForgeStepOne(false);
        setForgeCardStateOne([{}, {}, {}, {}, {}, {}]);
        getTokens();
        setShowForgeSuccessful(true);
    }

    const forgeNowConfirm = async () => {
        console.info('Start Forging')
        // srcTokenId is the source token that the user will send with the transaction
        // and true / false are values for layers that get moved from source to destination
        const lastIndex = 5;
        const dstTokenId = forgeCardStateOne[lastIndex].tokenId;
        const srcTokenId = uploadCard.find(card => card.id !== dstTokenId).id;
        const moveLayers = forgeCardStateOne.reduce((result, token, index) => {
            if (index < lastIndex) {
                result.push(token.tokenId === srcTokenId)
            }
            return result
        }, [])

        try {
            setShowLoader(true);
            const encodedLayers = forgeUtil.encodeLayerTransfer(dstTokenId, srcTokenId, ...moveLayers);
            const signer = ec.connect(ethersProvider.getSigner());
            let tx = await signer['safeTransferFrom(address,address,uint256,bytes)'](address, forgeContract.address, srcTokenId, encodedLayers)
                .catch(e => toast.error(parseRpcError(e.message)));
            if (tx) {
                let res = await tx.wait().catch((e) => { toast.error(e.reason) });
                if (res) {
                    clearAll();
                } else {
                    console.error('Some error occured! : res not found!')
                    setShowLoader(false);
                }
            } else {
                console.error('Some error occured! : tx not found!')
                setShowLoader(false);
            }
        } catch (e) {
            console.error(e);
            toast.error(e);
            setShowLoader(false);
        }
    }

    const resolveCardType = (tokenId) => {
        return tokenId < 10 ? 4 : tokenId < 100 ? 0 : tokenId < 1000 ? 1 : 3
    }
    const resolveTokenJsonUri = (tokenId) => {
        return baseCid + '/' + tokenId % 100 + '/' + tokenId + '.json'
    }

    const renderEligibleAmount = () => {
        return (
            <div className="row" style={{ marginTop: 'auto' }}>
                <p className="col-12 text-center" style={{ fontWeight: 500 }}>
                    Cards in your wallet: <span className="text-white">{eligibleCardAmount}</span>
                </p>
            </div>)
    }

    const renderConnectButton = () => {
        return (
            <div className="row">
                <div className="col-md-4 mx-auto mt-5 text-center">
                    <h5>In order to see your tokens, you need to connect your wallet</h5>
                    <button className="btn btn-peach btn-outline mx-auto mt-5 px-4" onClick={() => { onboard.walletSelect() }}>CONNECT</button>
                </div>
            </div>
        )
    }

    const renderInfoPopup = () => {
        return (
            <Popup
                trigger={<img id="infoBtn" src={icInfo}></img>}
                position="right top"
                on="click">
                {close =>
                    <div class="info-popup">
                        <h3 class="mb-4">Forge Cards</h3>
                        <p class="mb-4">You need at least two Ether Cards First Edition cards. Simply
                        drag & drop them into the placeholders on the top. Then continue with the
                        Forge button. The Forged card will be placed into your wallet.
                        <br></br>
                            <br></br>
                            <span className="text-white">Note: </span>
                        It may take some time for the layers to be updated
                        </p>
                        {/* <button class="btn btn-peach btn-outline text-white mt-2 px-4">READ MORE</button> */}
                        <img class="info-close-button" src={icClose} onClick={() => close()}></img>
                    </div>
                }
            </Popup>
        )
    }

    const renderDroppableUploadCard = (droppableId, hasForgeProtector, tokenMetadata, handleRemoveCard) => {
        return (
            <Droppable droppableId={droppableId}>
                {(provided, snapshot) => (
                    <div
                        {...provided.droppableProps}
                        style={getDroppableStyle(snapshot.isDraggingOver)}
                        ref={provided.innerRef}
                    >
                        {
                            tokenMetadata ?
                                <>
                                    <NftCardV2
                                        demoMode="true"
                                        tokenJson={tokenMetadata}
                                        showLayerFirst={true}
                                        cardType={resolveCardType(tokenMetadata.id)}
                                        tokenImage={null}
                                        showImage={showImage}
                                    />
                                    <div className="overlay-forging" >
                                        {hasForgeProtector &&
                                            <div className="forge-protector text-white">
                                                <img height={30} src={icForgeProtector}></img>  Forge Protector
                                            </div>
                                        }
                                        {showCardHoldings &&
                                            <div className="remove-button" onClick={() => handleRemoveCard()}>
                                                <img height={30} src={icClose}></img>
                                            </div>
                                        }
                                        <div className='bottom-text text-white'>
                                            <div>ID {tokenMetadata && tokenMetadata.id}</div>
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                    <div className='plus-button'>
                                        <img height={60} src={icDnd}></img>
                                    </div>
                                    <div className='bottom-text' style={{ fontWeight: 500 }}>
                                        Drag & Drop your card here
                                    </div>
                                </>
                        }
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        )
    }

    const renderSelectableLayers = (tokenMetadata) => {
        return (
            tokenMetadata && getLayersURI(tokenMetadata.layer_image, tokenMetadata.layer_artists).map((layer, i) => {
                const tokenId = tokenMetadata.id;
                return (
                    <div key={`layer_${tokenId}_${i}`} className={`layer-card-container ${forgeCardStateOne[i].tokenId === tokenId ? 'selected' : ''}`} onClick={() => handleSelectLayer(tokenId, i)}>
                        <img src={`${layersBaseUrl}/${layer.url}`}>
                        </img>
                        <div className="layer-name">{`${i + 1}. ${layer.artist}`}</div>
                    </div>
                );
            })
        )
    }

    return (
        <div id="forgeContainer" style={getForgeContainerStyle()}>
            <Navigation />
            <DragDropContext onDragEnd={onDragEnd}>
                <section id="forgeSection" style={forgeSectionStyle()}>
                    <div className="container mt-3 pt-3 text-center d-flex flex-column">
                        <h3 className="mb-3">The Forge {renderInfoPopup()}
                        </h3>
                        {
                            <div style={{ fontWeight: '500' }}>Uploaded Cards <span className="text-white">{uploadCardAmount}/2</span></div>

                        }
                        <div className="row" style={{ padding: '20px', justifyContent: 'center' }}>
                            <div className="col two-col">
                                <div className="upload-card-container" ref={uploadCardRef}>
                                    {renderDroppableUploadCard('uploadCardOne', hasForgeProtector[0], uploadCard[0], () => handleRemoveCard(0, uploadCard[0]))}
                                </div>
                            </div>
                            <div className="col two-col">
                                <div className="upload-card-container">
                                    {renderDroppableUploadCard('uploadCardTwo', hasForgeProtector[1], uploadCard[1], () => handleRemoveCard(1, uploadCard[1]))}
                                </div>
                            </div>
                        </div>
                        {
                            showButton && showCardHoldings &&
                            <div className='row'>
                                <div className="col-6 text-right">
                                    <button
                                        className="btn btn-peach btn-outline px-4 text-white"
                                        onClick={() => { back() }}>BACK
                                    </button>
                                </div>
                                <div className="col-6 text-left">
                                    <button
                                        className="btn btn-peach btn-outline px-4 text-white"
                                        onClick={() => { forgeNow() }}>FORGE
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                    {showForgeSuccessful &&
                        <div className="overlay-forge-success text-center">
                            <h2>Congratulations!</h2>
                            <div className="py-4" style={{ fontWeight: 500 }}>
                                You have successfully forged the cards.
                                <br></br>
                                Please find your brand new forged card inside your wallet
                                <br></br>
                                <span className="text-white">Note: </span>
                                It may take some time for the layers to be updated
                            </div>
                            <div>
                                <button
                                    className="btn btn-peach btn-outline px-4 text-white"
                                    onClick={() => { setShowForgeSuccessful(false) }}>CLOSE
                                </button>
                            </div>
                        </div>
                    }
                </section>

                {/* Holdings Section */}
                <section id="cardsSection" className={`d-flex flex-column ${!showCardHoldings && 'hide'}`}>
                    {isConnected ?
                        <div className="container mt-3">
                            {isLoading ?
                                <div className="col-lg-12 mt-5 mb-5 text-center">
                                    <SpinnerDotted enabled={isLoading} size={35} thickness={160} speed={200} color="#fff" />
                                </div>
                                :
                                <>
                                    {renderEligibleAmount()}
                                    <Droppable droppableId="cards" direction="horizontal">
                                        {(provided) => (
                                            <div className="row mx-auto mt-4" {...provided.droppableProps} ref={provided.innerRef}>
                                                {cards.map((metadata, i) => (
                                                    <Draggable
                                                        isDragDisabled={showForgeSuccessful}
                                                        key={`draggable_${metadata.id}`}
                                                        draggableId={`${metadata.id}`}
                                                        index={i} >
                                                        {(provided, snapshot) => {
                                                            return (
                                                                <div
                                                                    className="col-6 col-sm-6 col-md-4 col-lg-3 mb-3"
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    style={getStyle(provided.draggableProps.style, snapshot)}
                                                                    key={`card_${metadata.id}`}>
                                                                    <div style={getItemStyle(snapshot.isDragging)}>
                                                                        <NftCardV2
                                                                            demoMode="true"
                                                                            tokenJson={metadata}
                                                                            showLayerFirst={true}
                                                                            cardType={resolveCardType(metadata.id)}
                                                                            tokenImage={null}
                                                                            showImage={showImage}
                                                                            showForgeHistory={showForgeHistory}
                                                                        />
                                                                        <div className='card-text' style={{ fontWeight: '500' }}>
                                                                            Card ID: <span style={{ color: 'white' }}>{metadata.id}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }}
                                                    </Draggable>
                                                ))}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                    {cards.length === 0 &&
                                        <div className="col-md-6 mx-auto mt-5 text-center">
                                            <h5>Your wallet is empty.</h5>
                                        </div>
                                    }
                                </>
                            }
                        </div>
                        :
                        renderConnectButton()
                    }
                </section>
            </DragDropContext>

            <section id="layerSection" className={`d-flex flex-column ${!showForgeStepOne && 'hide'}`}>
                <div className="container">
                    <div className="row" style={{ justifyContent: 'center' }}>
                        <div className="col text-center" style={{ maxWidth: '40%', minWidth: '300px' }}>
                            <div style={{ fontWeight: 500 }}><span className="text-white">Note: </span>
                        Please select the layers you wish to keep and then click "Confirm Forge"
                        at the bottom
                        </div>
                        </div>
                    </div>
                    <div className="row text-center" style={{ padding: '0 20px 0 20px', justifyContent: 'center' }}>
                        <div className="col two-col">
                            {renderSelectableLayers(uploadCard[0])}
                        </div>
                        <div className="col two-col">
                            {renderSelectableLayers(uploadCard[1])}
                        </div>
                    </div>
                    <div className="row" style={{ padding: '20px', justifyContent: 'center' }}>
                        <div className="col text-center" style={{ maxWidth: '40%', minWidth: '300px' }}>
                            <h4>Preview</h4>
                            <div className="merge-card-container">
                                {
                                    forgeCardStateOne.map((state, i) => {
                                        if (state.tokenId && i < 5) {
                                            let cardMetadata = uploadCard.find(card => card && `${card.id}` === `${state.tokenId}`);
                                            if (cardMetadata) {
                                                let layersUri = getLayersURI(cardMetadata.layer_image, cardMetadata.layer_artists);
                                                let layer = layersUri[i];
                                                let src = `${layersBaseUrl}/` + layer.url;
                                                return (<img key={`merged_layer_${i}`} src={src}></img>);
                                            }
                                        }
                                    })
                                }
                                <div className="ec-logo" style={{ width: '80%', marginLeft: "10%" }}>
                                    <img src={ecLogo} alt="ethercards" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        showConfirmForgeButton &&
                        <div className='row'>
                            <div className="col-12 col-sm-6 text-center text-sm-right order-2 order-sm-1 mb-2">
                                <button
                                    className="btn btn-peach btn-outline px-4 text-white"
                                    onClick={() => { back() }}>BACK
                                        </button>
                            </div>
                            <div className="col-12 col-sm-6 text-center text-sm-left order-1 order-sm-2 mb-2">
                                <button
                                    className="btn btn-peach btn-outline px-4 text-white"
                                    onClick={() => { forgeStepTwo() }}>CONFIRM FORGE 1/2
                                        </button>
                            </div>
                        </div>
                    }
                </div>
            </section>

            <section id="traitsSection" className={`d-flex flex-column ${!showForgeStepTwo && 'hide'}`}>
                <div className="container text-center">
                    <div className="col col-md-6 offset-md-3">
                        <div className="note"><span className="text-white">Note: </span>
                        Select the card that you wish to keep.
                        </div>
                        <div className='warning-block'>
                            <span className="text-white">Warning: </span>
                            In order to forge two cards, you must sacrifice one of them.
                            If you are using Forge Protector, select the card WITHOUT this Trait as the card to keep.
                            The Trait will ensure that you keep both cards.
                        </div>
                    </div>
                    <div className="row text-center" style={{ padding: '0 20px 0 20px', justifyContent: 'center' }}>
                        <div className="col two-col">
                            {
                                showForgeStepTwo &&
                                <CardTraits tokenMetadata={uploadCard[0]} state={forgeCardStateOne} handleSelectCardTrait={handleSelectCardTrait} />
                            }
                        </div>
                        <div className="col two-col">
                            {
                                showForgeStepTwo &&
                                <CardTraits tokenMetadata={uploadCard[1]} state={forgeCardStateOne} handleSelectCardTrait={handleSelectCardTrait} />
                            }
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col">
                            {
                                showConfirmForgeButton &&
                                <div className='row'>
                                    <div className="col-12 col-sm-6 text-sm-right order-2 order-sm-1 mb-2">
                                        <button
                                            className="btn btn-peach btn-outline px-4 text-white"
                                            onClick={() => { back() }}>BACK
                                        </button>
                                    </div>
                                    <div className="col-12 col-sm-6 text-sm-left order-1 order-sm-2 mb-2">
                                        <button
                                            className="btn btn-peach btn-outline px-4 text-white"
                                            onClick={(e) => { forgeNowConfirm() }}>CONFIRM FORGE 2/2
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </section>

            <ImageView src={cardArtwork} onClose={() => setCardArtwork('')} />
            <ForgeHistory tokenId={showTokenIdHistory} onClose={() => setShowTokenIdHistory('')} />
            {
                showLoader &&
                <div className="forge-loader">
                    <div>
                        <SpinnerDotted enabled={true} size={35} thickness={160} speed={200} color="#fff" />
                        <h4 className="mt-2">Forging...</h4>
                    </div>
                </div>
            }
        </div >
    )
}

export default ForgePage;